import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useCurrencies } from '../../context/CurrencyContext';
import { DEFAULT_CURRENCY, getCurrency } from '../../utils/currency';

/**
 * Selector de moneda. Si el tenant solo tiene una moneda habilitada no se muestra (la pantalla se ve igual
 * que antes de multimoneda); `alwaysShow` fuerza mostrarlo, ej. para ver una moneda ya guardada.
 */
export default function CurrencySelect({
  value,
  onChange,
  label = 'Moneda',
  disabled = false,
  alwaysShow = false,
  size = 'small',
  fullWidth = true,
  sx,
}) {
  const { currencies, multiCurrency } = useCurrencies();
  if (!multiCurrency && !alwaysShow) return null;

  const current = getCurrency(value || DEFAULT_CURRENCY).code;
  // Si la moneda guardada ya no está habilitada se sigue mostrando, para no esconder el dato.
  const options = currencies.some((c) => c.code === current) ? currencies : [getCurrency(current), ...currencies];

  return (
    <FormControl size={size} fullWidth={fullWidth} disabled={disabled} sx={sx}>
      <InputLabel>{label}</InputLabel>
      <Select label={label} value={current} onChange={(event) => onChange(event.target.value)}>
        {options.map((c) => (
          <MenuItem key={c.code} value={c.code}>{`${c.symbol} · ${c.label}`}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
